// extracted by mini-css-extract-plugin
module.exports = {"avatarCell":"avatarCell--If9kX"};